import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SignUpComponent } from '../sign-up/sign-up.component';
import { UtilsService } from '../../shared/utils.service';
import { Router } from '@angular/router';
import {LogosCompany} from "../../shared/logos-company.model";
import {DataService} from "../../shared/data.service";
import { RmImageSliderComponent } from 'rm-image-slider';

@Component({
    selector: 'app-home-script',
    templateUrl: './home-script.component.html',
    styleUrls: ['./home-script.component.scss'],
    standalone: false
})
export class HomeScriptComponent implements OnInit {
  @ViewChild('bVideo', { static: true }) bunnyVideo: any;
  @ViewChild('replayButton', { static: true }) replay: any;
  @ViewChild('nav') slider: RmImageSliderComponent;

  
  showReplay = false;
  showPlay = true;
  logosList = new Array<any>();

  constructor(public dialog: MatDialog, public utils: UtilsService, private router: Router,
              private dataService: DataService,) {
   }

  ngOnInit(): void {
    this.utils.setTitle('Home');
    this.dataService.get('logos/RetrieveAllCompanies').then((data) => {
      if (data.statusCode === 200) {
        this.logosList = [];
        const logosData = data.data.records;
        logosData.forEach((logoData) => {
          const logoInstance = {
            image: logoData.picturePath,
            thumbImage: logoData.picturePath,
            alt: logoData.title,
            title: logoData.title
          };
          this.logosList.push(logoInstance);
        });
      }
    });
  }

  vidEnded() {
    this.showReplay = true;
}

  openSignup() {
      this.router.navigate(['/pricing']);
  }
  toggleVideo() {
    this.showReplay = false;
    this.showPlay = false;
    this.bunnyVideo.nativeElement.play();
  }

}
